const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/therapies.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/admin/therapies")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});